import { render, staticRenderFns } from "./CoVideoEmbed.vue?vue&type=template&id=38e1d4df&scoped=true&"
import script from "./CoVideoEmbed.vue?vue&type=script&lang=ts&"
export * from "./CoVideoEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./CoVideoEmbed.vue?vue&type=style&index=0&id=38e1d4df&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1d4df",
  null
  
)

export default component.exports